var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "none",
    stroke: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 4.53333H3.54167H14.875",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 4.53333V3.11666C5.66675 2.74094 5.816 2.38061 6.08168 2.11493C6.34736 1.84925 6.70769 1.7 7.08342 1.7H9.91675C10.2925 1.7 10.6528 1.84925 10.9185 2.11493C11.1842 2.38061 11.3334 2.74094 11.3334 3.11666V4.53333M13.4584 4.53333V14.45C13.4584 14.8257 13.3092 15.1861 13.0435 15.4517C12.7778 15.7174 12.4175 15.8667 12.0417 15.8667H4.95841C4.58269 15.8667 4.22236 15.7174 3.95668 15.4517C3.691 15.1861 3.54175 14.8257 3.54175 14.45V4.53333H13.4584Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cd88af4566e9afe1d5e645c311337bb9.svg";
export { ForwardRef as ReactComponent };